'use client'

import type { Cta, PointOfInterestImage } from 'landings/Home/Home.type'
import { type ReactNode, useRef } from 'react'

import { ButtonCtas } from '../Shared/ctas/ButtonCtas/ButtonCtas'
import { useActiveLink } from '../Shared/ctas/hooks/onActiveLink'
import styles from './HeroBannerSecondaryLines.module.css'
import { HeroBannerSecondaryLinesImage } from './HeroBannerSecondaryLinesImage/HeroBannerSecondaryLinesImage'
import { HeroBannerSecondaryLinesTitles } from './HeroBannerSecondaryLinesTitles/HeroBannerSecondaryLinesTitles'

type HeroBannerSecondaryLinesComponentProps = {
	readonly title: string
	readonly subTitle: string
	readonly image: PointOfInterestImage
	readonly ctas: Cta[]
	readonly isPrioritySlot: boolean | undefined
}

export function HeroBannerSecondaryLinesContent({
	title,
	subTitle,
	image,
	ctas,
	isPrioritySlot,
}: HeroBannerSecondaryLinesComponentProps): ReactNode {
	const ref = useRef<HTMLDivElement>(null)
	const activeLink = useActiveLink(ref)

	return (
		<div className={styles.bannerWrapper} ref={ref}>
			<HeroBannerSecondaryLinesImage image={image} priority={isPrioritySlot} />
			<div className={styles.bannerContainer}>
				<HeroBannerSecondaryLinesTitles
					subTitle={subTitle}
					title={title}
					isSingleCta={ctas.length === 1}
				/>
				<ButtonCtas
					ctas={ctas}
					activeLink={activeLink}
					className={styles.ctas}
					data-testid='landings.home.heroBannerSecondaryLinesLink'
				/>
			</div>
		</div>
	)
}
